export default __webpack_public_path__ + "static/media/kiss.538502ec.svg";